import styled from 'styled-components';
import ImageUploader from '../../components/ImageUploader/ImageUploader';
import { StyledImageHolder } from '../../components/ImageUploader/ImageUploader.styles';

export const StyledImageUploader = styled(ImageUploader)<{ backgroundColor?: string }>`
  width: 200px;
  position: relative;

  &:after {
    content: "";
    position: absolute;
    bottom: 0;
    z-index: -1;
    width: 100%;
    height: 125px;
  }
  
  ${StyledImageHolder} {
    background-color: ${props => props.url ? props.backgroundColor || 'none' : "#f5f5f5"};
    height: 70px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
`;

export const StyledContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;
